import React, { createContext, useContext } from 'react';
import { NotificationContainer, NotificationManager } from 'react-notifications';

const GlobalAlertsContext = createContext();

export const useGlobalAlerts = () => {
    return useContext(GlobalAlertsContext);
};

export const GlobalAlertsProvider = ({ children }) => {
    const showAlert = (title, message, type) => {
        switch (type) {
            case 'success':
                NotificationManager.success(message, title);
                break;
            case 'error':
                NotificationManager.error(message, title);
                break;
            case 'warning':
                NotificationManager.warning(message, title);
                break;
            case 'info':
                NotificationManager.info(message, title);
                break;
            default:
                break;
        }
    };

    return (
        <GlobalAlertsContext.Provider value={{ showAlert }}>
            {children}
            <NotificationContainer />
        </GlobalAlertsContext.Provider>
    );
};